export default "<p>billing-report-filter works!</p>\r\n";